import React, { Component, useEffect, useState, useRef } from 'react';
import { DownloadField } from './dependencies/constant/searchConstant'
import { getStateList, getSectorList, dowloadReport, generateReport, downloadExcelFile, GenerateSuiReport, RefreshSuiReport, downloadSuiPreviusReport, lastGeneratedReportHistory } from './dependencies/action';
import { getIndustryList, getStartupSector } from '../../components/startupApplication/dependencies/action'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import SectionTitle from '../common/sectionTitle/sectionTitle';
import './styles.scss'
import moment from 'moment/moment';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import downArrowBtn from '../../assests/images/down-arrow-btn.png';
import { useLoading } from '../LoadingContext';
import LoadingBar from '../LoadingBar';
import { toast } from "react-toastify";


const MonthlyDetailsReport = (props) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const { downloadSuiPreviusReport } = props;
    const [selectedFields, setSelectedFields] = useState(DownloadField);
    const [openHistory, setOpenHistory] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [lastThreeMonths, setLastThreeMonths] = useState([]);
    const [historyData, setHistoryData] = useState({});
    const { loading, setLoading } = useLoading();


    useEffect(() => {
        const months = [];
        const today = new Date();
        let targetMonth = today.getMonth() - 1;
        let targetYear = today.getFullYear();
        for (let i = 0; i < 3; i++) {
            if (targetMonth === -1) {
                targetMonth = 11;
                targetYear -= 1;
            }
            const targetDate = new Date(targetYear, targetMonth, 1);
            const monthName = targetDate.toLocaleString('default', { month: 'long' });
            const monthNumber = `${String(targetMonth + 1).padStart(2, '0')}-${targetYear}`;
            months.push({
                name: `${monthName} ${targetYear}`,
                number: monthNumber
            });
            targetMonth -= 1;
        }
        setLastThreeMonths(months);
    }, []);

   



    async function handleDownloadPreviousSuiReport(e) {
    e.preventDefault();
    setLoading(true);

    if (downloadSuiPreviusReport && e.target.value) {
        const headers = selectedFields.reduce((arr, option) => {
            if (option['dataField']) {
                arr.push(option['dataField']);
            }
            return arr;
        }, []);

        let query = {
            endDate,
            startDate,
            headers
        };

        for (const prop in query) {
            if (!query[prop] || (Array.isArray(query[prop]) && query[prop].length === 0)) {
                delete query[prop];
            }
        }

        try {
            const response = await downloadSuiPreviusReport({
                query,
                month: e.target.value 
            });

            const fileUrl = response?.data?.url;

           if (typeof fileUrl === "string" && fileUrl.startsWith("http")) {
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = "report.xlsx";
                // a.target = "_blank";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else {
                toast.error(fileUrl);
            }

        } catch (error) {
            console.error("Error downloading report:", error);
        } finally {
            setLoading(false);
        }
    } else {
        setLoading(false);
    }
}



    const closeHistoryModal = () => {
        setOpenHistory(false);
    }

    const handleOpenDropdown = () => {
        setOpenDropdown(!openDropdown);
    }

    return (
        <>
            <div className="startup-report">
                <SectionTitle>Monthly Detailed Report</SectionTitle>
                <div className="filter-form custom-form" >


                    <div className="row">
                        <div className="col-md-12">
                            <div className='d-flex justify-content-between Refresh-abt'>
                                <label className='fields-line'>Fields</label>
                            </div>
                            <div className='fields-list '>
                                <ul>
                                    {DownloadField?.map((el => <>
                                        <li className='someOtherClass'>{el?.text}</li>
                                    </>))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className={`col-sm-12 d-flex justify-content-between pt-20 mb-3 `}>
                            
                            <div class="dropdown-wrapper">
                                <div
                                    onClick={handleOpenDropdown}
                                    className={`download-container bttn dropdown-check ${openDropdown ? 'show' : ""}`}
                                >
                                    Report History <img className='img' width="15" src={downArrowBtn} />
                                    <ul>
                                        {lastThreeMonths?.map((el, index) => (
                                            <li key={index} >
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value={el?.number}
                                                        id={`checkbox-${index}`}
                                                        name="month"
                                                        onClick={(event) => handleDownloadPreviousSuiReport(event)}
                                                    />
                                                    <label className="form-check-label" htmlFor={`checkbox-${index}`}>
                                                        {`up to(${el?.name})`}
                                                    </label>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading && (
                                <div className="spinners">
                                    <LoadingBar />
                                    <span>⏳ Generating Report...</span>
                                </div>
                            )}
                </div >
            </div>
            <Modal isOpen={openHistory} toggle={closeHistoryModal} className="last-generated-report">
                <ModalHeader toggle={closeHistoryModal}>
                    Last Downloaded Report
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className='last-generated'>
                            <ul>
                                {historyData && historyData['Date'] && historyData["StartDate"] && historyData['EndDate'] &&
                                    <>
                                        <li><strong>Name : </strong> <p>{historyData['Name']}</p></li>
                                        <li><strong>Date : </strong> <p>{moment(historyData['Date']).format('DD/MM/YYYY')}</p></li>
                                        <li><strong>Query : </strong> <p> {`Since ${moment.utc(historyData["StartDate"]).format('DD/MM/YYYY')} - ${moment.utc(historyData['EndDate']).format('DD/MM/YYYY')}`}</p></li>
                                    </>
                                }
                            </ul>
                        </div>

                    </div>

                </ModalBody>
                <ModalFooter>
                    <div className="button-container">
                        <button className="download-container downloadReport-Generated" onClick={(event) => closeHistoryModal(event)}>
                            Ok
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        StateList: state.StartupDetailReport.reportStateList,
        IndustryList: state.startupApplicationForm.startupIndustry,
        SectorList: state.startupApplicationForm.startupEntitySector,
    }
}

export default connect(mapStateToProps, { lastGeneratedReportHistory, getStartupSector, getSectorList, getStateList, dowloadReport, generateReport, downloadExcelFile, getIndustryList, GenerateSuiReport, RefreshSuiReport, downloadSuiPreviusReport })(withRouter(MonthlyDetailsReport));